(function () {
  function run() {
    var sel = document.querySelector('variant-selects');
    if (!sel) return;

    var jsonEl = sel.querySelector('[data-product-variants]');
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    // Gerçek stok haritası (inventory_quantity > 0). Yoksa available'a düş.
    var stockMap = null;
    var stockEl = sel.querySelector('[data-variant-stock]');
    if (stockEl) {
      try {
        stockMap = JSON.parse(stockEl.textContent);
      } catch (e) {
        stockMap = null;
      }
    }

    function isInStock(v) {
      if (stockMap && Object.prototype.hasOwnProperty.call(stockMap, String(v.id))) {
        return stockMap[String(v.id)] === true;
      }
      return v.available === true;
    }

    var urlId = new URLSearchParams(window.location.search).get('variant');
    var current = variants.find(function (v) {
      return String(v.id) === String(urlId);
    });

    if (current && isInStock(current)) return;

    var first = variants.find(isInStock);
    if (!first) return;

    if (String(first.id) === String(urlId)) return;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', String(first.id));
    window.location.replace(url.toString());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
